export default function PoliceDocumentsDetails () {
    return (
    <div>

<div className="police-bg bg-image">
            <div className="gap-spacer"></div>
            <div className="page-title mobile-center-title top-cap-outlines">
                <h1>Morrisville Borough Police</h1>
            </div>
            {/*Start Main Content*/}
            <div className="police-center-container mid-side-outlines">
                
                           
                {/*Start Police Sub-Menu*/}
                <div className="police-sub-menu">
                    <div className="logo"></div>
                    <input className="menu-btn" type="checkbox" id="menu-btn"/>
                    <label className="menu-icon" for="menu-btn"><i className="fa-solid fa-bars"></i>&nbsp;Police Sub-Menu</label>
                    <ul className="menu">
                        <li><a href="/police">General</a></li>
                        <li><a href="https://bucks.crimewatchpa.com/morrisvillepd/34776">CrimeWatch&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                        <li><a href="/police/documents">Documents</a></li>
                        <li><a href="/police/jobs">Jobs</a></li>
                        <li><a href="/police/personnel">Personnel</a></li>
                        <li><a href="/police/resources">Resources</a></li>
                        <li><a href="https://bucks.crimewatchpa.com/morrisvillepd/34776/submit-tip">Submit-A-Tip&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                        <li><a href="/police/statistics">Statistics</a></li>
                    </ul>
                </div>
                {/*End Police Sub-Menu*/}

            
            {/*Start Section Below Sub-Menu*/}
            <div className="police-center-container">
			<div className="left-right-padding-1em">
                <br/>
				<h4>Documents</h4>
				
				<h3><a href="../docs/police/Citizen-Complaint-Form.pdf">
						<i className="fa-solid fa-file-pdf fa-xl"></i>&nbsp;
						Citizen Complaint Form</a></h3>
				The Morrisville Borough Police Department holds its employees to the highest ethical standards, and we are committed to providing fair and impartial high-level police services to all community members and visitors. Accordingly, we will accept and investigate all complaints regarding the conduct of any member of this police department. All complaints are investigated to a logical conclusion, and complainants are notified of each outcome.
				<p>To initiate a citizen complaint, please use the fillable form below and return it to:</p>
				<b>Chief Rich Ciampa<br/>
					Morrisville Borough Police Department<br/>
					35 Union Street<br/>
					Morrisville, PA 19067<br/>
				</b>
				<hr/>
					<h4>Right To Know Requests</h4>
			</div>
		</div>
			<div className="mb-960-center-container">
				{/*Full Width Element*/}
    <div className="mb-960-col-50p">
        <div className="left-right-padding-1em">
            <br/>
            <h4>RTK Officer</h4>
            <b>Sue Knott</b> <p>
            <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street Morrisville, PA 19067</a><br/>
            <a href="tel:2152958181"><i className="fa-solid fa-phone"></i>&nbsp;215-295-8181</a><br/>
            <a href="tel:2157363760"><i className="fa-solid fa-fax"></i>&nbsp;215-736-3760<br/></a>
            <a href="mailto:sknott@morrisvilleboro.org"><i className="fa-solid fa-envelope"></i>&nbsp;sknott@morrisvilleboro.org</a></p>

            <h4>RTK Information</h4>
            <p>For regulations, policies, and procedures related to the “Right To Know Law” <a href="http://www.openrecords.pa.gov">please click here to go to the PA OOR website: http://www.openrecords.pa.gov&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
            <h4>RTK Form</h4>
            <p><a href="../docs/rtk/PA-RTKRequestForm.pdf"><i className="fa-solid fa-file-pdf"></i>&nbsp;Click here for a copy of the PA State RTK form that can be used to submit RTK requests to Morrisville Borough</a></p>
        </div>
    </div>
    <div className="mb-960-col-50p">
        <div className="left-right-padding-1em">
            <br/>
            <h4>Submitting an RTK Request</h4>
            Completed RTK forms may be submitted in the following ways:
            <ul>
                <li>Submitted in person at Morrisville Borough Hall<br/> <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                        <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street Morrisville, PA 19067</a>, between the hours of 8:00 a.m. and 4:30 p.m. on normal work days.</li>
                <li> Mailed to Morrisville Borough Hall at <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                        <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union Street Morrisville, PA 19067</a></li>
                <li> E-mailed to the Open Records Officer, Sue Knott, at <a href="mailto:sknott@morrisvilleboro.org"><i className="fa-solid fa-envelope"></i>&nbsp;sknott@morrisvilleboro.org</a> with the subject of the e-mail reading: Open Records Request</li>
                <li> Submitted via Fax: <a href="tel:2157363760"><i className="fa-solid fa-fax"></i>&nbsp;215-736-3760<br/></a></li>
            </ul>

            <h4>Related Documents</h4>
            <table id="filetable">
                <tr>
                    <th>File Name</th>
                    <th>Date Posted</th>

                </tr>
                {/*Start File*/}
                <tr>
                    <td><a href="../docs/rtk/PA-RTKRequestForm.pdf">
                            <i className="fa-solid fa-file-pdf fa-xl"></i>&nbsp;
                            Right-To-Know Request Form</a></td>
                    <td>09/17/2024</td>
                    {/*End File*/}
                </tr>
            </table>
					</div>
				</div>
                </div>
                </div>
            <div className="page-footer bottom-cap-outlines">&nbsp;</div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>

            </div>
            
            
            
            


</div>
    )
}